module.exports = "/src/views/player/help/images/gov.jpg";